import { put, takeLatest, call } from "redux-saga/effects";
import * as memberAction from "../../actions/ActionCreator";
import * as memberType from "../../actions/ActionType";
import { API_ENDPOINT } from "../../URLs/ApiEndpoints";
import * as Api from "../../../appApi/AppApi";

const TAG = "InviteUserAdminPortalSaga.js";

function* workerInviteUserAdminPortal(payLoad) {
  console.log(TAG, "INvite admin portal User : " + JSON.stringify(payLoad));
  try {
    const response = yield call(
      Api.makeSecuredPostRequest,
      API_ENDPOINT.INVITE_USER_ADMIN_PORTAL,
      payLoad.data
    );
    yield put(memberAction.createActionOf(memberType.INVITE_USER_SUCCESS_ADMIN_PORTAL, 1, response));
  } catch (error) {
    console.error(TAG, "Worker get country failed: " + error.message);
    yield put(memberAction.createActionOf(memberType.INVITE_USER_FAILED_ADMIN_PORTAL, 2,error));
    // throw new Error("Error: inside saga", JSON.stringify(error));
  }
}

export const watchInviteUserAdminPortal = takeLatest(
  memberType.INVITE_USER_REQUESTED_ADMIN_PORTAL,
  workerInviteUserAdminPortal
);
